import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { OauthFlowParams } from '../../complete/state/complete_state';
import { ENV } from '../../../environment';
import { AccountService } from '../../../shared/services/account.service';
import { Credentials } from '../../../shared/models/credentials';
import { UserService } from '../../../shared/services/user.service';
import { concatMap, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class RegistrationService {

  private validRedirectHosts: string[];

  constructor (private http: HttpClient, private authService: AuthService,
               private accountService: AccountService,  private userService: UserService) {
    this.validRedirectHosts = ENV.AllowedRedirectHosts.split(',');
    let linkElement = document.createElement('a');
    linkElement.href = ENV.YotpoB2bEndpoint;
    this.validRedirectHosts.push(linkElement.hostname);
  }

  completeOauthFlow(originalParams: OauthFlowParams, newPassword?: string, displayName?: string): Observable<any> {
    let body = Object.assign({}, originalParams);
    if (newPassword) {
      body['password'] = newPassword;
    }
    if (displayName) {
      body['display_name'] = displayName;
    }
    let utoken = this.authService.getCredentials().utoken;
    if (utoken) {
      body['utoken'] = utoken;
    }

    if (typeof originalParams['email'] !== 'undefined' && typeof originalParams['product'] !== 'undefined') {
        return this.updatePasswordAndGetToken(newPassword,  originalParams['reset_password_token'],
          originalParams['email']).pipe(concatMap((token: any) => {
          let credentials = new Credentials(originalParams['appkey'], token);
          this.authService.setCredentials(credentials);

          let params = {
            action_params: {context: 'provision_account'},
            product_category: originalParams['product'],
            admin_info: {email: originalParams['email'], first_name: displayName},
            store_info: {app_key: this.authService.getCredentials().appKey}
          };

          return this.accountService.enable_product(params).pipe(
            map((response: any) => { return { redirect_to: response.status.redirect_url, context: 'sign-up' }; }));
        }));
    } else {
      let linkElement = document.createElement('a');
      linkElement.href = originalParams.finalize_url;
      if (this.validRedirectHosts.indexOf(linkElement.hostname) < 0) {
        return throwError('invalid hostname in redirect url: ' + originalParams.finalize_url);
      }

      return this.http.post(originalParams.finalize_url, body);
    }
  }

  private updatePasswordAndGetToken(password, resetToken, email): Observable<any> {
    return this.userService.updatePassword(resetToken, password, password, email).pipe(
      concatMap((updatedUser: any) =>
        this.userService.emailPasswordLogin(updatedUser.email, password)));
  }
}
